export type ProductPrice = {
  productId: number;
  mainWebShopId: number;
  webShopId: number;
  shopNumber: string;
  market: string;
  mainWebShop: string;
  hasDifferentPrices: boolean;
  unavailableOnline: boolean;
  colours: Array<ProductPriceColour>;
  currencyCode: string;
  currencySign: string;
  currencySignHtml: string;
  standardPrice: number;
  sellPrice: number;
  rrpPrice: number;
  emPrice: number;
  lowestPrice: number; // Lowest Discounted Price 30 Days
  active: boolean;
  lowestSkuSellPrice: number;
  links?: Array<string>;
  productDiscountPercentage: number;
  productDiscountAmount: number;
  ccExcluded?: boolean;
  hdExcluded?: boolean;
  fulfillmentCopyDescriptions?: {
    EN: string;
    FR: string;
    NL: string;
  };
};

export type ProductPriceColour = {
  colourId: number;
  productColourId: number;
  priceState: number;
  webThumbOverlayCode?: string;
  webThumbOverlayPicture?: string;
  srpPriceMax: number;
  noDiscount: boolean;
  markdown: boolean;
  standardPrice: number;
  sellPrice: number;
  rrpPrice: number;
  emPrice: number;
  lowestPrice: number;
  active: boolean;
  colourHasDifferentPrices: boolean;
  skus: Array<ProductPriceColourSKU>;
  maxDiscount: number;
  colourDiscountPercentage: number;
  colourDiscountAmount: number;
};

export type ProductPriceColourSKU = {
  skuId: number;
  costPrice?: number;
  priceState: number;
  standardPrice: number;
  sellPrice: number;
  rrpPrice: number;
  emPrice?: number;
  lowestPrice?: number; // Lowest Discounted Price 30 Days
  active: boolean;
  productDiscountPercentage: number;
  productDiscountAmount: number;
};

export type ProductDetailPriceData = {
  colours: Array<ProductDetailPriceDataForColor>;
  fulfillment?: ProductFulfillment;
  unavailableOnline: boolean;
};

export type ProductDetailPriceDataForColor = {
  colourId: number;
  discountPercentage?: number;
  discountAmount?: number;
  hasDifferentPrices: boolean;
  hasDiscount: boolean;
  markdown: boolean;
  prices: ProductPrices;
  priceOverlay: {
    code?: string;
    thumb?: string;
    idOverlayBackground?: number;
    overlayBackgroundCodeDescription?: string;
  };
  sizes: Array<ProductDetailPriceDataForColorSize>;
  financeProviders?: Array<FinanceProvider>;
};

export type ProductDetailPriceDataForColorSize = {
  skuId: number;
  discountPercentage?: number;
  discountAmount?: number;
  prices: ProductPrices;
};

export type ProductFulfillment = {
  ccExcluded?: boolean;
  hdExcluded?: boolean;
  fulfillmentCopyDescription?: string;
};

export type ProductPriceOverlay = {
  overlayCode?: string;
  overlayThumb?: string;
  idOverlayBackground?: number;
  overlayBackgroundCodeDescription?: string;
};

export type ProductPrices = {
  SELL: ProductPriceViewModel;
  STD?: ProductPriceViewModel;
  RRP?: ProductPriceViewModel;
  EM?: ProductPriceViewModel;
  LOWEST?: ProductPriceViewModel;
};

export type ProductPriceViewModel = {
  intPrice?: number; // We don't ever use this
  decPrice?: number; // We don't ever use this
  original: number;
  priceState?: string | number | null;
};

export type FinanceProvider = {
  provider: string;
  plans: Array<MonthlyPaymentPlan>;
};

export type MonthlyPaymentPlan = {
  months: number;
  rate: number;
  deposit: number;
  monthlyPayment: number;
};

export type TotalPrice = {
  totalSellPrice: number;
  totalStandardPrice: number;
};
